<div class="row" *ngIf="path">
  <div class="col">
    <app-path-selector
      [(path)]="path"
      [(editing)]="editing"
      [readonly]="readonly"
      (pathChange)="onPathChange($event)"
      (editingChange)="onEditingChange($event)"
    ></app-path-selector>
  </div>
  <div *ngIf="leafs" class="col-auto my-auto">
    <button type="button" class="btn btn-md btn-primary" (click)="expanded = !expanded">
      {{ leafs.length }} Nodes
      <fa-icon [icon]="expanded ? 'chevron-down' : 'chevron-right'" [fixedWidth]="true"></fa-icon>
    </button>
  </div>
  <div *ngIf="!editing && !element.node" class="col-auto my-auto">
    <span class="text-danger"> Node does not exist </span>
  </div>
  <ng-container *ngIf="expanded">
    <div *ngFor="let leaf of leafs" class="col-12 text-secondary indent">
      <app-path-selector [path]="leaf" [offset]="path.length - 1" [readonly]="true"></app-path-selector>
    </div>
  </ng-container>
</div>
